<template>
  <a-form-model class="form" :model="form" ref="editForm" :rules="rules">
    <a-form-model-item label="大标题" prop="title">
      <a-input v-model="form.title" placeholder="文件列表大标题"></a-input>
    </a-form-model-item>
    <a-form-model-item label="文件列表">
      <div class="item-list">
        <a-form-model class="item-form" v-for="(a, i) in items" :key="i">
          <a-form-model-item label="文件名称">
            <a-input v-model="a.name" placeholder="文件名称"></a-input>
          </a-form-model-item>
          <a-form-model-item label="文件上传">
            <a-upload
              v-model="a.fileurl"
              class="file-upload"
              action="#"
              :show-upload-list="false"
              :before-upload="beforeUploadFile"
              :custom-request="(param) => uploadFile(param, i)"
            >
              <a-button v-if="!a.fileurl">上传文件</a-button>
              <ul v-if="a.fileurl" class="m-file-list">
                <li class="m-file-item">{{ a.name }}</li>
                <a-icon
                  type="close"
                  class="file-close icon-close"
                  @click.stop="removeFile(i)"
                ></a-icon>
              </ul>
            </a-upload>
          </a-form-model-item>
          <a-icon type="close" class="icon-close" @click="remove(i)" />
        </a-form-model>
      </div>
      <div class="add-item" @click="addItem">
        <div class="add-icon"></div>
        <div class="add-txt">添加文件</div>
      </div>
    </a-form-model-item>
    <template v-if="form.more">
      <a-form-model-item label="卡片“更多”文字">
        <a-input v-model="form.more.title"></a-input>
      </a-form-model-item>
      <a-form-model-item label="卡片“更多”链接">
        <a-input v-model="form.more.url"></a-input>
      </a-form-model-item>
    </template>
    <a-form-model-item label="标题加粗">
      <a-switch v-model="form.bold"></a-switch>
    </a-form-model-item>
    <a-form-model-item label="卡片分割线">
      <a-switch v-model="form.itemLine"></a-switch>
    </a-form-model-item>
    <a-form-model-item label="标题分割线">
      <a-switch v-model="form.topLine"></a-switch>
    </a-form-model-item>
    <a-form-model-item label="内层间距" v-if="form.padding">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.padding.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.padding.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.padding.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.padding.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="外层间距" v-if="form.margin">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.margin.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.margin.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.margin.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.margin.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="背景色">
      <colorPicker
        class="color-picker shadow"
        v-model="form.backgroundColor"
      ></colorPicker>
    </a-form-model-item>
    <template v-if="form.content">
      <a-form-model-item label="内容内层间距" v-if="form.content.padding">
        <a-space>
          <a-input
            type="number"
            class="inline-input"
            placeholder="上"
            v-model="form.content.padding.top"
          ></a-input>
          <a-input
            type="number"
            class="inline-input"
            placeholder="下"
            v-model="form.content.padding.bottom"
          ></a-input>
          <a-input
            type="number"
            class="inline-input"
            placeholder="左"
            v-model="form.content.padding.left"
          ></a-input>
          <a-input
            type="number"
            class="inline-input"
            placeholder="右"
            v-model="form.content.padding.right"
          ></a-input>
        </a-space>
      </a-form-model-item>
      <!-- <a-form-model-item label="内容圆角">
        <a-input type="number" v-model="form.content.borderRadius"></a-input>
      </a-form-model-item> -->
      <a-form-model-item label="内容背景色">
        <colorPicker
          class="color-picker top shadow"
          v-model="form.content.backgroundColor"
        ></colorPicker>
      </a-form-model-item>
    </template>
    <a-form-model-item label="是否在首页显示">
      <a-switch v-model="form.isShow"></a-switch>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { clone, getPrefixName } from "../../common/js/tool";
import { directUploadTencentCloud } from "../../common/js/tencent_cloud";

export default {
  name: "file-edit",
  props: {
    value: Object,
  },
  data() {
    return {
      form: {},
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
      items: [],
    };
  },
  watch: {
    form: {
      handler() {
        this.update();
      },
      deep: true,
    },
    items: {
      handler() {
        this.update();
      },
      deep: true,
    },
    value() {
      this.setValue();
    },
  },
  created() {
    this.setValue();
  },
  methods: {
    setValue() {
      if (this.value) {
        let temp = clone(this.value);
        this.items = temp.list;
        delete temp.list;
        this.form = temp;
      }
    },
    addItem() {
      this.items.push({
        name: null,
        title: null,
        duty: null,
        company: null,
        url: null,
        avatar: null,
      });
    },
    remove(i) {
      this.items.splice(i, 1);
    },
    update() {
      let temp = clone(this.form);
      temp.list = clone(this.items);
      this.$emit("change", temp);
    },
    validate() {
      let msg = null;
      if (!this.form.title) {
        msg = "请输入文件列表大标题";
      }
      return msg;
    },
    beforeUploadFile(file) {
      //传之前先检测下文件格式和大小
      //console.log(file)
      const fileType = file.name.replace(/.+\./, "");
      const type = ["txt", "pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx"];
      if (type.indexOf(fileType) === -1) {
        this.$message.warning("请上传正确的文件格式");
        return false;
      }
      // const size = file.size/1024/1024
      // if(size>5){
      //     this.$message.warning('请不要上传5M以上的文件')
      //     return false
      // }
      return true;
    },
    uploadFile(param, i) {
      // console.log("param:", param, "i:", i);
      let file = param.file;
      directUploadTencentCloud(file).then((data) => {
        //console.log(data)
        let path = "https://" + data.Location;
        const item = this.items[i];
        item.fileurl = path;
        item.url = path;
        item.name = getPrefixName(file.name);
        this.$set(this.items, i, item);
      });
    },
    removeFile(i) {
      const item = this.items[i];
      item.fileurl = null;
      item.url = null;
      item.name = null;
      this.$set(this.items, i, item);
    },
  },
};
</script>

<style lang="less">
.file-upload .ant-upload {
  text-align: left;
  display: flex;
}
.ant-upload ul {
  width: 200px;
  margin-bottom: 0;
}
.ant-upload li {
  width: 80%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.file-close {
  top: 28px;
}
</style>

<style lang="less" scoped>
.color-picker::v-deep {
  .colorBtn {
    width: 20px;
    height: 20px;
  }
}
</style>
